<template>
  <v-layout row wrap>
    <v-flex style="padding:10px;" xs12 sm4 md4>
      <v-text-field label="Column" @change="onFilterChanged" v-model="filter.column" />
    </v-flex>
    <v-flex style="padding:10px;" xs12 sm3 md3>
      <v-select label="Operator" @change="onFilterChanged" v-model="filter.operator" :items="filter_operators"></v-select>
    </v-flex>
    <v-flex style="padding:10px;" xs12 sm4 md4>
      <v-text-field label="Value" @change="onFilterChanged" v-model="filter.value" />
    </v-flex>
    <v-flex style="padding:10px;" xs12 sm1 md1>
      <i @click="deleteFilter" class="fal fa-times" style="padding-top:22px;cursor:pointer;"></i>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    filter: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      filter_operators: [
        "==",
        "==i",
        "<",
        ">",
        "contains",
        "contains_i",
        "starts",
        "starts_i",
        "ends",
        "ends_i",
      ],
    };
  },
  methods: {
      onFilterChanged() {
          this.$emit("change", this.filter.id);
      },
      deleteFilter() {
          this.$emit("delete", this.filter.id);
      }
  }
};
</script>

<style>
</style>